import { TreeSelect } from 'antd';
import React, { useState } from 'react'

function TreeMultiSelect({options, placeholder, className, disabled, onChange, value, inputId}) {

    const [open, setOpen] = useState(false);
    // const [value, setValue] = useState();

    // const onChange = (newValue) => {
    //   console.log(newValue);
    //   setValue(newValue);
    // };

    function handleSelect(){
      setOpen(!open);
      }

      function handleClick(){
        setOpen(!open);
      }

      function handleSearch(){
        setOpen(true);
      }
  
  return (
    <TreeSelect multiple
    onChange={(e)=>onChange(e, inputId)}
    value={value}
    treeData={options}
    placeholder={placeholder}
    open={open}
    onSearch={() => handleSearch()}
    onSelect={()=>handleSelect()}
    onClick={()=>handleClick()}
    onFocus={() => setOpen(true)}
    onBlur={() => setOpen(false)}
    className={className}
    disabled={disabled}
    treeDefaultExpandAll
    switcherIcon= {() => <></>}
    />
  )
}

export default TreeMultiSelect;
